export const MenuListData = [
  {
    name: "Dashboards",
    to: "#",
    header: true,
  },
  {
    name: "Dashboard",
    icon: "os-icon os-icon-layout",
    to: "/",
  },
  {
    name: "Applications",
    to: "#",
    header: true,
  },
  {
    name: "Products",
    icon: "os-icon os-icon-package",
    to: "#",
    subs: [
      [
        {
          name: "Upload Product",
          to: "/product/upload",
        },
        { name: "Product List", to: "/products/items/productv2", created: "01-01-2020" },
        // { name: "Sponsor Product", to: "/sponsor/list", created: "01-01-2020"s },
        {
          name: "Mass Upload",
          to: "/product/mass/list",
        },
      ],
      [
        {
          name: "Product Group",
          to: "/options/productGroup",
        },
      ],
    ],
  },
  {
    name: "Orders",
    icon: "os-icon os-icon-shopping-cart",
    to: "#",
    subs: [
      [
        {
          name: "Order Management",
          to: "/order/pre_list",
        },
        {
          name: "Order Loginless",
          to: "/orders/loginless",
        },
        {
          name: "Customer Order Return",
          to: "/order/customer/return",
        },
        {
          name: "Order Template",
          to: "/order/template",
        },
      ],
    ],
  },
  {
    name: "FB Orders",
    icon: "os-icon os-icon-facebook",
    to: "#",
    subs: [
      [
        {
          name: "Review Payment",
          to: "/fborder/review_payment",
        },
        {
          name: "Orders",
          to: "/fborder/orders",
        },
        {
          name: "Alias Items",
          to: "/fborder/alias_item",
        },
      ],
    ],
  },
  {
    name: "Inventory",
    icon: "os-icon os-icon-home",
    to: "#",
    subs: [
      [
        {
          name: "Inventory Shipment",
          to: "/applications/inventories/list",
        },
        {
          name: "View Shipment Log",
          to: "/applications/inventories/log",
        },
        {
          name: "Inventory SKU",
          to: "/applications/inventories/sku",
        },
      ],
      [
        {
          name: "Inventory Removal",
          to: "/inventory/removal",
        },
        {
          name: "Seller Package",
          to: "/inventory/package",
        },
        {
          name: "Abnormal Shipment",
          to: "/inventory/abnormal",
        },
      ],
    ],
  },
  {
    name: "Disbursement",
    icon: "os-icon os-icon-dollar-sign",
    to: "#",
    subs: [
      [
        {
          name: "Disbursement Log",
          to: "/applications/disbursement/log",
        },
        {
          name: "Request Disbursement",
          to: "/applications/disbursement/request",
        },
      ],
    ],
  },
  {
    name: "Marketing",
    icon: "os-icon os-icon-ui-02",
    to: "#",
    subs: [
      [
        {
          name: "Discount Manager",
          to: "/discount/list",
        },
        { name: "Product Review", to: "/review" },
        {
          name: "Ads Campaign",
          to: "/products/campaign/list",
        },
        {
          name: "Promo Code",
          to: "/options/promo/campaigns",
        },
      ],
      [
        {
          name: "Event Campaign",
          to: "/market/event_campaign",
        },
        {
          name: "Promo Combo",
          to: "/market/promo_combo",
        },
        {
          name: "Topup History",
          to: "/topup/history",
        },
      ],
    ],
  },
  {
    name: "Package",
    icon: "os-icon os-icon-ui-02",
    to: "#",
    subs: [
      [
        {
          name: "Create Package",
          to: "/packages/create/sheet",
        },
        {
          name: "Package Draft",
          to: "/packages/package_draft",
        },
        {
          name: "Package in Progress",
          to: "/packages/package_progress",
        },
        {
          name: "Package History",
          to: "/packages/package_history",
        },
        {
          name: "Package Abandoned",
          to: "/packages/package_abandoned",
        },
      ],
    ],
  },
  {
    name: "Options",
    to: "#",
    header: true,
  },
  {
    name: "Brands",
    icon: "os-icon os-icon-package",
    to: "#",
    subs: [
      [
        { name: "My Brand", to: "/options/brand/list", created: "01-01-2020" },
        {
          name: "L192 Brand",
          to: "/options/brand/l192",
        },
      ],
    ],
  },
  {
    name: "Vendors",
    icon: "os-icon os-icon-users",
    to: "/options/vendor/list",
  },
  {
    name: "Store Decorator",
    icon: "os-icon os-icon-aperture",
    to: "/custom/page",
  },
  // {
  //   name: "POS",
  //   icon: "os-icon os-icon-airplay",
  //   to: "/pos",
  // },
  {
    name: "Top up",
    icon: "os-icon os-icon-coins-4",
    to: "#",
    subs: [
      [
        { name: "Advertising Fee", to: "/account/payment/advertising" },
        { name: "Affiliate Fee", to: "/account/payment/affiliate" },
      ],
    ],
  },
  {
    name: "Reports",
    to: "#",
    header: true,
  },
  {
    name: "Reports",
    icon: "os-icon os-icon-file-text",
    to: "#",
    subs: [
      [
        { name: "Sale Report", to: "/reports/salereport", created: "01-01-2020" },
        {
          name: "Delivery Location",
          to: "/reports/delivery",
        },
        { name: "Search", to: "/reports/search" },
        { name: "Inventory", to: "/reports/inventory" },
        { name: "Product Performance", to: "/reports/product_performance" },
        { name: "Product Click Through Rate", to: "/reports/product_click_through_rate" },
        { name: "Customer Cohort", to: "/reports/cohort" },
      ],
    ],
  },
];

export const MenuListDataShipperLogic = [
  {
    name: "Applications",
    to: "#",
    header: true,
  },
  {
    name: "Tracking Code",
    to: "/",
  },
];

export const MenuListDataShipper = [
  {
    name: "Applications",
    to: "#",
    header: true,
    id: "application_shipper",
  },
  {
    name: "Order Shipment",
    to: "/",
    id: "application_shipper",
  },
  {
    name: "Inventory Shippment",
    to: "/inventory",
    id: "application_shipper",
  },
  {
    name: "Seller Package",
    to: "/package_seller",
    id: "application_shipper",
  },
];
